import { render, staticRenderFns } from "./PricingCardsTablet.vue?vue&type=template&id=abd17110&"
import script from "./PricingCardsTablet.vue?vue&type=script&lang=js&"
export * from "./PricingCardsTablet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports